export class CopyObjectParams {
  artifact_id: string;
  object_type: string;
}
